import { stateTypes, getterTypes } from './specification.moduletypes';

import {} from '../models/specification.models';

import actions from './specification.moduleactions';
import mutations from './specification.modulemutations';

import SpecificationApi from '../services/specification.api';

export default {
  // see https://vuex.vuejs.org/guide/modules.html#namespacing
  namespaced: true,

  state: {
    [stateTypes.specificationSelections]: {},
    [stateTypes.unitsWithSpecification]: [],
    [stateTypes.currentlyEditedSpecification]: {}
  },
  getters: {
    [getterTypes.SpecificationApi]: (state, getters, rootState) => {
      // let settings = rootState.applicationState
      //   ? rootState.applicationState.initialSettings
      //   : window.infos.initialSettings;
      return new SpecificationApi();
    },
    [getterTypes.getSpecificationSelections]: state => {
      return state[stateTypes.specificationSelections];
    },
    [getterTypes.getAllUnitsWithSpecification]: state => {
      return state[stateTypes.unitsWithSpecification];
    },
    [getterTypes.getCurrentlyEditedSpecification]: state => {
      return state[stateTypes.currentlyEditedSpecification];
    }
  },

  mutations: mutations,

  actions: actions
};
